module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="participant-' +
((__t = ( unique_id )) == null ? '' : __t) +
'">\n    <div class="participant-name"><strong>' +
((__t = ( name )) == null ? '' : __t) +
'</strong> ' +
((__t = ( full_title || title )) == null ? '' : __t) +
'</div>\n    <div class="participant-term-bar"></div>\n    <div class="participant-end-term-bar"></div>\n    <img class="participant-photo" src="' +
((__t = ( photo_url )) == null ? '' : __t) +
'" >\n</div>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/participant-term.html
// module id = 137
// module chunks = 0